import { Localized } from '../../internal/Localized';
import Styles from './Landing.module.css';
import { Label } from '@app/engine';

/** File-local constants for HowItWorksCard (decorative, non-translatable glyphs). */
const localConstants = {
  icon1: '📞',
  icon2: '🤖',
  icon3: '📅',
  icon4: '💬',
  icon5: '📊',
  icon6: '🔔'
} as const;

/** Props for a single how-it-works step. */
interface IStepProps {
  num: string;
  icon: string;
  title: string;
  desc: string;
}

/**
 * A single numbered step (number + icon + title + description).
 *
 * @param props - Component props.
 * @returns The step element.
 */
function Step(props: IStepProps) {
  return (
    <div className={Styles.step}>
      <Label text={props.num} classNameContainer={Styles.stepNum} />
      {/* Raw <span>: decorative emoji icon flagged aria-hidden; engine Label cannot set aria-hidden and would add a glyph title tooltip. */}
      <span className={Styles.stepIcon} aria-hidden="true">
        {props.icon}
      </span>
      <Label text={props.title} classNameContainer={Styles.stepTitle} />
      <Label text={props.desc} classNameContainer={Styles.stepDesc} />
    </div>
  );
}

/**
 * Card 3 — how it works. Six steps from inbound call to booked job.
 *
 * @returns The how-it-works card element.
 */
export function HowItWorksCard() {
  return (
    <section className={`${Styles.cardInner} ${Styles.cardHow}`}>
      <div className={Styles.cardTag}>
        <Label text={Localized.LandingHowLabel} classNameContainer={Styles.sectionLabel} />
        {/* Structural wrapper: a single Label cannot render the two-line styled headline, so a div is used and each line carries the tooltip. */}
        <div className={Styles.sectionTitle}>
          <Label text={Localized.LandingHowTitle1} title={`${Localized.LandingHowTitle1} ${Localized.LandingHowTitle2}`} />
          <br />
          <Label text={Localized.LandingHowTitle2} title={`${Localized.LandingHowTitle1} ${Localized.LandingHowTitle2}`} classNameContainer={Styles.accent} />
        </div>
      </div>
      <div className={Styles.cardBody}>
        <div className={Styles.steps}>
          <Step num={Localized.LandingHowStep1Num} icon={localConstants.icon1} title={Localized.LandingHowStep1Title} desc={Localized.LandingHowStep1Desc} />
          <Step num={Localized.LandingHowStep2Num} icon={localConstants.icon2} title={Localized.LandingHowStep2Title} desc={Localized.LandingHowStep2Desc} />
          <Step num={Localized.LandingHowStep3Num} icon={localConstants.icon3} title={Localized.LandingHowStep3Title} desc={Localized.LandingHowStep3Desc} />
          <Step num={Localized.LandingHowStep4Num} icon={localConstants.icon4} title={Localized.LandingHowStep4Title} desc={Localized.LandingHowStep4Desc} />
          <Step num={Localized.LandingHowStep5Num} icon={localConstants.icon5} title={Localized.LandingHowStep5Title} desc={Localized.LandingHowStep5Desc} />
          <Step num={Localized.LandingHowStep6Num} icon={localConstants.icon6} title={Localized.LandingHowStep6Title} desc={Localized.LandingHowStep6Desc} />
        </div>
      </div>
    </section>
  );
}
